import { useParams } from "react-router-dom";
import { Css } from "src/Css";
import { SearchBy, useHomeownerProjectsQuery } from "src/generated/graphql-types";
import { useHomeownerProjectSearchQuery } from "src/hooks";
import { ProjectRouteProps } from "src/routes";
import { NavBar } from ".";

interface PageLayoutProps {
  old?: boolean;
  children: React.ReactNode;
}

export function PageLayout({ children, old = false }: PageLayoutProps) {
  const { projectId } = useParams<ProjectRouteProps>();
  // Load all projects and current project as soon as you login successfully for caching purposes
  useHomeownerProjectsQuery();
  useHomeownerProjectSearchQuery(SearchBy.Project, projectId);

  return (
    <>
      <NavBar />
      <div css={Css.df.mh100.fdc.aifs.jcfs.ptPx(72).ifXs.pt8.$}>
        <div css={Css.w100.fg1.$}>
          <main
            css={{
              ...Css.dg.mh("calc(100vh - 72px)").ifXs.mh("calc(100vh - 64px)").$,
              ...(!old &&
                Css.ifMax // max
                  .gtc("repeat(12, 1fr)")
                  .gap3.mxPx(120)
                  // xl
                  .ifXl.gtc("repeat(12, 1fr)")
                  .gap3.mxPx(100)
                  // lg
                  .ifLg.gtc("repeat(12, 1fr)")
                  .gap3.mxPx(80)
                  // md
                  .ifMd.gtc("repeat(12, 1fr)")
                  .gap2.mx8 // sm
                  .ifSm.gtc("repeat(8, 1fr)")
                  .gap2.mx6 // xs
                  .ifXs.gtc("repeat(4, 1fr)").gap2.mx3.$),
            }}
          >
            {children}
          </main>
        </div>
      </div>
    </>
  );
}
